<span class="label">{{ link.label }}</span>

<div class="container">
  <div
    *ngFor="let experienceLink of link.experienceLinks | slice: 0 : MAX_SIZE_EXPERIENCES; last as isLast;"
    class="link"
    (click)="experienceLinkSelected.emit(experienceLink)"
    [class.last-element]="isLast && !expanded()"
    [tabIndex]="0">
    <span class="title"> {{ experienceLink.name }} </span>
    <opac-icon icon="navigate_next"></opac-icon>
  </div>

  <div class="container" *ngIf="expanded()" @expandCollapse>
    <div
      *ngFor="let experienceLink of link.experienceLinks | slice: MAX_SIZE_EXPERIENCES; first as isFirst; last as isLast;"
      class="link"
      [class.first-element]="isFirst"
      [class.last-element]="isLast"
      (click)="experienceLinkSelected.emit(experienceLink)"
      [tabIndex]="0">
      <span class="title"> {{ experienceLink.name }} </span>
      <opac-icon icon="navigate_next"></opac-icon>
    </div>
  </div>

  <opac-button
    *ngIf="link.experienceLinks?.length > MAX_SIZE_EXPERIENCES"
    type="text"
    (click)="expanded.set(!expanded())"
    [showTooltip]="false"
    [tooltipLabel]="expandedLabel() | translate">
    {{ expandedLabel() | translate }}
    <opac-icon slot="end" icon="navigate_downward" [class.expanded]="expanded()"></opac-icon>
  </opac-button>
</div>
